export default "__VITE_ASSET__BFhOZlxJ__"